import {
  FormatPaint,
  Domain,
  Business,
  Home,
  Store,
  School,
  MenuBook,
  LocalHospital,
  Restaurant,
  Computer,
  DesignServices,
  Construction,
  DirectionsCar,
  AccountBalance,
  SelfImprovement,
  SportsTennis,
  GolfCourse,
  Campaign,
  Language,
  Female,
  WbIncandescent,
  Public,
  Sports,
} from "@mui/icons-material";
import React from "react";

// Mapping des slug aux composants d'icônes
export const iconMap: Record<string, React.ComponentType<any>> = {
  Domain: Domain,
  Business: Business,
  Home: Home,
  Store: Store,
  School: School,
  LocalHospital: LocalHospital,
  Restaurant: Restaurant,
  Computer: Computer,
  DesignServices: DesignServices,
  Construction: Construction,
  DirectionsCar: DirectionsCar,
  AccountBalance: AccountBalance,
  SelfImprovement: SelfImprovement,
  SportsTennis: SportsTennis,
  GolfCourse: GolfCourse,
  Campaign: Campaign,
  Language: Language,
  Female: Female,
  WbIncandescent: WbIncandescent,
  Public: Public,
  Sports: Sports,
  MenuBook: MenuBook,
};

export const getIconBySlug = (slug?: string): React.ComponentType<any> => {
  if (!slug) return FormatPaint;
  return iconMap[slug] || FormatPaint;
};
